import * as React from "react";
import { ITrustpilot } from "../models/ITrustpilot.model";
declare var Trustpilot: any;

function TrustPilot(props: ITrustpilot) {

	if(!props.Show) {
		return null;
	}

	React.useEffect(() => {
		if(document) {
			const trustbox = document.querySelector('.js-basket-trustpilot-widget');
			if (typeof Trustpilot != "undefined") {
				Trustpilot.loadFromElement(trustbox);
			}
		}
	}, []);

	return (
		<div className="mBasketReviews u-hide-print" data-test="basket-reviews-container">
			<div className="trustpilot-widget js-basket-trustpilot-widget" data-locale="en-GB" data-template-id={props.DateTemplateId} data-businessunit-id={props.DateBusinessUnit} data-style-height="20px" data-style-width="100%" data-theme="light">
				<a href={`https://uk.trustpilot.com/review/${props.Handle}`} target="_blank" rel="noopener">Trustpilot</a>
			</div>
		</div>
	);


}

export default TrustPilot;
